// Page
import Register from "../components/Registration/Register/index.js";

const RegisterPage = () => {
    return (
        <Register/>
    )
}

export default RegisterPage;